import styled from 'styled-components'

export const RegistrationFormReCaptcha = styled.div`
  display: flex;
  justify-content: center;
`

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.colors.semantic.error};
  text-align: center;
`
